import { inject, Injectable } from '@angular/core';
import { MongoAssortment } from '../../models/mongo-assortment';
import { ProductSelectionService } from '../product-selection-service/product-selection.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GungModalService } from '../gung-modal/gung-modal.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../auth/auth.service';
import { MongoAssortmentService } from '../mongo-assortment/mongo-assortment.service';
import { ProductService } from '../products/product.service';
import { forkJoin, Observable } from 'rxjs';
import { first, map, switchMap } from 'rxjs/operators';
import { Product } from '../../models';
import { MongoAssortmentCreateModalComponent } from '../../components/mongo-assortment-create-modal/mongo-assortment-create-modal.component';
import { ActionButton, ActionButtonConfigService } from 'gung-common';

@Injectable({
  providedIn: 'root'
})
export class MongoAssortmentActionButtonConfigService implements ActionButtonConfigService<MongoAssortment> {
  protected selectionService = inject(ProductSelectionService);
  protected modalService = inject(NgbModal);
  protected mongoAssortmentService = inject(MongoAssortmentService);
  protected gungModalService = inject(GungModalService);
  protected translateService = inject(TranslateService);
  protected authService = inject(AuthService);
  protected productService = inject(ProductService);

  getButtons(item: MongoAssortment): Observable<ActionButton<MongoAssortment>[]> {
    return this.authService.getRoles().pipe(
      first(),
      map(roles => {
        const actions = [];
        actions.push({
          title: 'SELECT_ASSORTMENT',
          displayAsButton: true,
          action: (ma: MongoAssortment) => {
            this.productService.getProductsByAssortmentExpanded(ma.id).pipe(first()).subscribe(products => {
              this.selectionService.clearSelection();
              this.selectionService.select(products.map(product => ({ id: product.id } as Product)));
              this.modalService.dismissAll();
            });
          }
        });

        if (roles.includes('ADMIN')) {
          actions.push(
            {
              title: 'UPDATE_WITH_CURRENT_PRODUCT_SELECTION',
              displayAsButton: false,
              action: (ma: MongoAssortment) => {
                this.selectionService
                  .getSelection()
                  .pipe(
                    first(),
                    map(selection => {
                      ma.children = Object.values(selection.selectedItems).map(p => p.id);
                      return ma;
                    }),
                    switchMap(assortment => forkJoin([this.mongoAssortmentService.create(assortment).pipe(first())]))
                  )
                  .subscribe(([]) => {});
              }
            },
            {
              title: 'EDIT',
              displayAsButton: false,
              action: (ma: MongoAssortment) => {
                const modal = this.modalService.open(MongoAssortmentCreateModalComponent);
                modal.componentInstance.mongoAssortment = ma;
                modal.componentInstance.isUpdate = true;
              }
            },
            {
              title: 'DELETE',
              displayAsButton: false,
              action: (ma: MongoAssortment) => {
                this.gungModalService
                  .openConfirmYesNoModal(undefined, this.translateService.instant('DELETE_ASSORTMENT_CONFIRM'), {
                    size: 'sm'
                  })
                  .then(
                    result => {
                      if (result) {
                        this.mongoAssortmentService
                          .deleteById(ma.id)
                          .pipe(first())
                          .subscribe(_ => {});
                      }
                    },
                    reason => {}
                  );
              }
            }
          );
        }
        return actions;
      })
    );
  }
}
